import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TemplatesService } from 'src/app/services/application-resources/templates.service';
import { Observable, of } from 'rxjs';
import { TemplateText } from 'src/app/services/application-resources/models/template-resource-data';

@Component({
    selector: 'app-template-text-list-container',
    templateUrl: './template-text-list.container.html',
    standalone: false
})
export class TemplateTextListContainer implements OnInit {
  @Input() templatesKey: string;
  @Output() onTemplateClick = new EventEmitter<string>();

  constructor(private templatesService: TemplatesService) {}

  templateTexts$: Observable<TemplateText[]>;

  ngOnInit(): void {
    this.templateTexts$ = of(
      this.templatesService.getTextsForKey(this.templatesKey)
    );
  }

  templateClicked(templateText: string): void {
    this.onTemplateClick.emit(templateText + '\n');
  }
}
